import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Success.css';

const Cancel = () => {
  const navigate = useNavigate();

  return (
    <div className='success-page__container'>
      <div className='success-page__card'>
        <div className='success-page__error-icon'>&#10008;</div>
        <h2 className='success-page__title'>Payment Cancelled</h2>
        <p className='success-page__message'>
          Your payment was not completed. You can return to checkout and try again.
        </p>
        <button type='button' onClick={() => navigate('/subscriptions')}>
          Return to checkout
        </button>
      </div>
    </div>
  );
};

export default Cancel;
